export var getViewPurchasePermission = function (policy) {
    var policyPermission = policy.find(function (item) {
        return item.actions.toString() === ['view'].toString() &&
            item.resources.toString() === ['order'].toString();
    });
    return (policyPermission !== undefined && Array.isArray(policyPermission.filters));
};
export var getViewHistoryPayload = function (isActive) {
    return isActive
        ? [{ actions: ['view'], resources: ['order'] }]
        : [
            {
                filters: [
                    {
                        name: 'purchaserPHFilter',
                        filterAttributes: { owner: '$UserId' },
                        filterCandidate: { user: { role: 'PURCHASER', type: 'B2B' } },
                    },
                ],
                actions: ['view'],
                resources: ['order'],
            },
        ];
};
